import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'xs-lib-xs-lib',
  template: `
    <p>
      xs-lib works!
    </p>
  `,
  styles: [
  ]
})
export class XsLibComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
